import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatRM, formatDate } from "@/lib/api";
import { StatusBadge, ProcessTimeBadge } from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, RefreshCw } from "lucide-react";

export default function AgentJobs() {
  const [jobs, setJobs] = useState(null);
  const nav = useNavigate();
  const load = () => api.get("/agent/jobs").then((r) => setJobs(r.data));

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  if (!jobs) return <div className="text-muted-foreground">Loading...</div>;
  const active = jobs.filter((j) => !["Collected", "Cancelled"].includes(j.status)).length;

  return (
    <div className="space-y-4" data-testid="agent-jobs-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs font-mono text-muted-foreground uppercase">Live Progress</div>
          <h1 className="text-2xl font-display font-bold">My Jobs</h1>
          <p className="text-sm text-muted-foreground">{jobs.length} job • {active} active • auto-refresh 30s</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={load} data-testid="agent-refresh"><RefreshCw className="w-4 h-4" /></Button>
          <Button size="sm" onClick={() => nav("/agent/new")} className="bg-amber-400 hover:bg-amber-300 text-slate-950 font-semibold" data-testid="agent-new-order-btn"><Plus className="w-4 h-4 mr-1" /> New Order</Button>
        </div>
      </div>

      {jobs.length === 0 && (
        <Card className="p-10 text-center text-muted-foreground" data-testid="agent-empty">
          No jobs yet. Click "New Order" to submit your first order.
        </Card>
      )}

      <div className="grid gap-3">
        {jobs.map((j) => (
          <Card key={j.id} onClick={() => nav(`/agent/jobs/${j.id}`)} className="p-4 cursor-pointer hover:shadow-md transition flex flex-wrap items-center justify-between gap-3" data-testid={`agent-job-${j.job_number}`}>
            <div>
              <div className="font-mono font-bold">{j.job_number}</div>
              <div className="text-sm text-muted-foreground">{j.customer_name} • {j.product} × {j.quantity}</div>
              <div className="text-xs text-muted-foreground flex items-center gap-2">Process time: <ProcessTimeBadge job={j} /> • Target: {formatDate(j.deadline)}</div>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-mono text-sm">{formatRM(j.total_price)}</span>
              <StatusBadge status={j.status} />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
